import mapboxgl from 'mapbox-gl';

import { stl_blue_color } from 'theme/cemTheme';

import { MapStyle } from '../../../appConstants';

export const kDirectionArrowName = 'direction_arrow_selected';
export const kHoveredDirectionArrowName = 'direction_arrow_hover';
export const kHalfDirectionArrowNameLHD = 'direction_half_arrow_l';
export const kHalfDirectionArrowNameRHD = 'direction_half_arrow_r';
export const kBookmarkMarkerImg = 'bookmark_marker';
export const kQueuePositionMarkerImg = 'queue_marker';
export const kQueueStartMarkerImg = 'queue_start_marker';
export const kRoadworksIconImg = 'roadworks';
export const kTrafficIconImg = 'traffic';
export const kAccidentIconImg = 'accident';
export const kClosureIconImg = 'closure';
export const kDefaultIconImg = 'default';
export const kBarberPolePatternImg = 'barberpole_red';
export const kSolidDotImg = 'solid_dot';
export const kStarMarker = 'star_marker';

export const MAP_ICONS_TO_LOAD = [
  kHalfDirectionArrowNameLHD,
  kHalfDirectionArrowNameRHD,
  kBookmarkMarkerImg,
  kStarMarker,
  kQueuePositionMarkerImg,
  kQueueStartMarkerImg,
  kDirectionArrowName,
  kHoveredDirectionArrowName,
  kRoadworksIconImg,
  kTrafficIconImg,
  kAccidentIconImg,
  kDefaultIconImg,
  kBarberPolePatternImg,
  kSolidDotImg,
];
export const MAP_COLORED_ICONS_TO_LOAD = [kClosureIconImg];
export const MIN_MAP_ZOOM = 8; // for which layers are displayed
export const MIN_ZOOM = 5;
export const MAX_ZOOM = 18;
export const initZoom = 12;
export const safeCenter = { lat: 40, lng: -98 };
export const kMouseHoverTimeoutMillis = 300;

export const kProjectBoundaryLayerId = 'project_boundary';
export const kProjectMaskLayerId = 'project_mask';
export const kSelectedSegmentLayerId = 'selection';
export const kSelectedSegmentSymbolsLayerId = 'selectionSymbols';
export const kSegmentSymbolsLayerId = 'segmentSymbols';
export const kSelectedRouteLayerId = 'route';
export const kHoveredSegmentLayerId = 'hovered_segment';
export const kHoveredSegmentSymbolsLayerId = 'hovered_segment_symbols';
export const kHoveredSegmentSourceId = 'hovered_segment';

export const kSegmentLayerId = 'segments';
export const kSegmentSourceId = 'segments_source';
export const kSegmentHoverId = 'segments_hover';
export const kSegmentLayerSourceLayerId = 'segments'; // Matches kSegmentLayerId
export const kViewOnlySegmentLayerId = 'segments_viewonly';

export const kChartShowHideId = 'chart-showhide';
export const kSettingsControlId = 'map-settings-control';
export const kTicksShowHideId = 'ticks-showhide';
export const kRoadClassControlId = 'road-class-filter';
export const kMetricsSourceId = 'metrics_source';
export const kMetricsLayerId = 'metrics';
export const kMetricsHoverId = 'metrics_hover';
export const kMetricsSymbolsId = 'metrics_symbols';
export const kMetricsLayerSourceLayerId = 'segments';
export const kBookmarkLayerId = 'bookmarks';
export const kMonitorRouteLayerId = 'monitor';
export const kMonitorSymbolId = 'monitor_symbol';
export const kMonitorSymbolBgId = 'monitor_symbol_bg';
export const kMonitorRouteBorderLayerId = 'monitor_border';
export const kAlertRouteArrowLayerId = 'alert_route_arrows';
export const kIncidentPoILayerId = 'incidents_poi'; // Little icons
export const kIncidentFlowLayerId = 'incidents_flow'; // closure snakes
export const kIncidentSourceId = 'incidents';

export const kScenarioSegmentLayerId = 'scenario_segments';
export const kScenarioSegmentFillLayerId = 'scenario_segments_fill';
export const kScenarioSegmentCapLayerId = 'scenario_segments_cap';
export const kScenarioSegmentSymbolLayerId = 'scenario_segments_symbol';
export const kScenarioClosureLayerIds = [
  kScenarioSegmentFillLayerId,
  kScenarioSegmentLayerId,
  kScenarioSegmentCapLayerId,
  kScenarioSegmentSymbolLayerId,
];
export const kScenarioNonDetourLayerId = 'nondetour';
export const kScenarioNonDetourDashedLayerId = 'nondetour_dashed';

export const kQueueMapHoverLayerId = 'maphover';
export const kQueueSourceId = 'queue';
export const kQueueLayerId = 'queue';
export const kQueueRouteDimLayerId = 'queue_route_dim';
export const kQueueRouteSelectionSourceId = 'queue_route';
export const kRouteArrowsLayerId = 'arrows';
export const kRouteArrowsBgLayerId = 'arrows_bg';
export const kQueueUnderlayLayerId = 'queue_underlay';
export const kQueueTagmaLayerId = 'tagma';

export const kSubscriptionBoundarySourceId = 'subscription-boundary';
export const kSubscriptionBoundaryFadeLayerId = 'subscription-boundary-fade';
export const kSubscriptionBoundaryLineLayerId = 'subscription-boundary-line';
export const kSubscriptionProjectSourceId = 'subscription-projects';
export const kSubscriptionProjectLabelsSourceId =
  'subscription-projects-labels';
export const kSubscriptionProjectLineLayerId = 'subscription-projects-line';
export const kSubscriptionProjectFillLayerId = 'subscription-projects-fill';
export const kSubscriptionProjectLabelsLayerId = 'subscription-projects-labels';

export const kMapLayerStack = [
  kSegmentHoverId,
  kViewOnlySegmentLayerId,
  kSegmentLayerId,
  kHoveredSegmentSymbolsLayerId,
  kHoveredSegmentLayerId,
  kMetricsHoverId,
  kMetricsLayerId,
  kMetricsSymbolsId,
  kScenarioNonDetourLayerId,
  kScenarioSegmentFillLayerId,
  kScenarioSegmentLayerId,
  kScenarioSegmentCapLayerId,
  kScenarioSegmentSymbolLayerId,
  kMonitorRouteBorderLayerId,
  kMonitorRouteLayerId,
  kAlertRouteArrowLayerId,
  kQueueRouteDimLayerId,
  kSelectedRouteLayerId,
  kScenarioNonDetourDashedLayerId,
  kSelectedSegmentLayerId,
  kSelectedSegmentSymbolsLayerId,
  kMonitorSymbolBgId,
  kMonitorSymbolId,
  kBookmarkLayerId,
  kIncidentFlowLayerId,
  kIncidentPoILayerId,
  kQueueUnderlayLayerId,
  kQueueLayerId,
  kQueueTagmaLayerId,
  kQueueMapHoverLayerId,
  kRouteArrowsBgLayerId,
  kRouteArrowsLayerId,
  kProjectMaskLayerId,
  kProjectBoundaryLayerId,
];
export const mapMidContrastColorLm = '#787878';
export const mapHighContrastColorLm = '#000000';
export const projectBorderColor = '#cd5538';
export const projectBorderColorLm = '#cd5538';
export const selectedSegmentColor = '#FFFFFF';
export const selectedSegmentColorLm = '#3B3B3B';
export const favoriteRouteColor = '#f0cf7f';
export const favoriteRouteColorLm = '#FDCD30';
export const selectedRouteColor = '#529DFF';
export const selectedRouteColorLm = '#0099FF';
export const rmRouteColor = '#FFFFFF';
export const rmRouteColorLm = mapMidContrastColorLm;
export const hoveredRouteColor = 'rgb(82,157,255)';
export const hoveredRouteColorLm = 'rgba(0,153,255,0.6)';
export const baseSegmentColor = 'rgb(255,218,106)';
export const baseSegmentColorLm = '#FDCD30';
export const viewOnlyBaseSegmentColor = 'rgba(127,109,53,1)';
export const viewOnlyBaseSegmentColorLm = 'rgba(127,109,53,1)';
export const hoveredSegmentColor = 'rgba(255,255,255,0.6)';
export const hoveredSegmentColorLm = 'rgba(0,0,0,0.4)';
export const bookmarkMarkerColor = stl_blue_color;
export const bookmarkMarkerColorLm = '#0099FF';
export const kMaxScreenDistanceForSelect = 40;
export const kMaxScreenDistanceForRouteSelect = 200;
export const kLongTouchTimeMs = 600;
// export const mapBoxStyleKey = 'mapbox://styles/pfriedman/clpvhc0cn003o01qm6iom9820';
export const MAP_STYLE_LOOKUP = {
  [MapStyle.Dark]: 'mapbox://styles/stlgbartonowen/cltq4maic00ku01p54c0f1127',
  [MapStyle.Sat]: 'mapbox://styles/stlgbartonowen/clwshetae01lt01qefzjdc994',
  [MapStyle.Light]: 'mapbox://styles/stlgbartonowen/clx3t9flm02te01qmdfrb6mch',
};

export function make_symbol_width_expression(
  basis_width: number,
): mapboxgl.Expression {
  return [
    'interpolate',
    ['linear'],
    ['zoom'],
    MIN_MAP_ZOOM,
    3 * basis_width,
    14,
    6 * basis_width,
    16,
    8 * basis_width,
    19,
    20 * basis_width,
  ];
}
export function make_line_width_expression(
  basis_width: number,
): mapboxgl.Expression {
  return [
    'interpolate',
    ['linear'],
    ['zoom'],
    MIN_MAP_ZOOM,
    2 * basis_width,
    14,
    3 * basis_width,
    16,
    8 * basis_width,
    19,
    20 * basis_width,
  ];
}

export const border_thick_line_width_expression: mapboxgl.Expression = [
  'interpolate',
  ['linear'],
  ['zoom'],
  MIN_MAP_ZOOM,
  10,
  14,
  15,
  16,
  8 * 2.5,
  19,
  20 * 2.5,
];
export const thick_line_width_expression = make_line_width_expression(1.5);
export const line_width_expression = make_line_width_expression(1.0);
export const selection_line_width_expression = make_line_width_expression(1.5);
export const icon_size_expression = [
  'interpolate',
  ['linear'],
  ['zoom'],
  MIN_MAP_ZOOM,
  0.4,
  14,
  0.4,
  16,
  0.8,
  19,
  1,
];
export const kMainVisLineOpacity = 0.7;
export const kMainVisLineOpacityExpression = (baseOpacity: number) =>
  [
    'interpolate',
    ['linear'],
    ['get', 'frc'],
    0,
    baseOpacity,
    1,
    baseOpacity,
    5,
    0.2,
  ] as mapboxgl.Expression;
export const kMainVisLineOpacitySegmentSelected = 0.45;
export const kMainVisLineOpacitySegmentSelectedExpression = [
  'interpolate',
  ['linear'],
  ['get', 'frc'],
  0,
  kMainVisLineOpacitySegmentSelected,
  1,
  kMainVisLineOpacitySegmentSelected,
  5,
  0.2,
];

export const kArrowLayoutBase: mapboxgl.SymbolLayout = {
  'symbol-placement': 'line-center',
  'icon-image': kDirectionArrowName,
  'icon-rotate': 90,
  'icon-rotation-alignment': 'map',
  'icon-allow-overlap': true,
  'icon-ignore-placement': true,
  'icon-size': icon_size_expression as any,
};
